import React from "react";
import FormattedDate from "./FormattedDate";
import WeatherIcon from "./WeatherIcon";
import WeatherTemperature from "./WeatherTemperature";


export default function WeatherInfo(props) {
  return (
    <div className="WeatherInfo">
      <div className="row location-container">
        <div className="col-md-3 location">
          <div className="text-center">
            <h1>{props.data.city}</h1>
            <ul>
              <li className="mt-2">
                <FormattedDate date={props.data.date} />
              </li>
              <li className="text-capitalize">{props.data.description}</li>
            </ul>
            <div className="row mt-3">
              <div className="col-12">
                <WeatherIcon
                  code={props.data.icon} size={52}
                  alt={props.data.description}
                />
                <div className="float-left">
                  <WeatherTemperature celsius={props.data.temperature} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-9 mt-5">
          <div className="row">
            <div className="col">
              <ul className="items-list">
                <li>
                  <span>PRECIPTATION</span>
                  <span>15%</span>
                </li>
                <li>
                  <span>HUMIDITY</span>
                  <span>{props.data.humidity}%</span>
                </li>
                <li>
                  <span>WIND</span>
                  <span>{Math.round(props.data.wind)}km/h</span>
                </li>
                <li>
                  <span>MAX TEMP</span>
                  <span>{Math.round(props.data.Max)}°C</span>
                </li>
                <li>
                  <span>MIN TEMP</span>
                  <span>{Math.round(props.data.Min)}°C</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

